import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { EventLogTabContent } from './event-log-tab-content';

export function EventLogTab() {
    const eventId = useWorkspacePanel().linkedEntityId;

    return (
        <EventPanelTab title="Event Log">
            <TabBody constrainToParentHeight={true}>
                <EventLogTabContent eventId={eventId} />
            </TabBody>
        </EventPanelTab>
    );
}
